import React, { createContext, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Light mode only - no dark mode
  const isDarkMode = false;

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme: () => {} }}>
      <div className="light">
        {children}
      </div>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
